export const CHAR_SIZE = 11.6;
export const PADDING = 12;
